import React from 'react'

interface CalculatorButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
}

function CalculatorButton(props: CalculatorButtonProps) {
  const { children, value } = props
  const hasChildren = React.Children.count(children) > 0
  return (
    <button type="button" {...props}>
      {hasChildren ? children : <span>{value}</span>}
    </button>
  )
}

export default CalculatorButton

